import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import Basic_cloud from 'images/Basic_cloud.png';
import BCIF_Container from '../BCIF_Container';
import { Table, TableCell, TableContainer, TableRow } from '@mui/material';
import { TableBody } from '@material-ui/core';

const usePrevious = value => {
  const ref = useRef(null);
  useEffect(() => { ref.current = value; });
  return ref.current;
};

const App = ({ windId }) => {
  const [height, setHeight] = useState(0);
  const containRef = useRef();
  const dispatch = useDispatch();
  const getBIBasicInfo = () => Actions_Wind.getBIBasicInfo(dispatch, { windId });
  const clearKey = key => Actions_Wind.clearKey(dispatch, { key });
  const BIBasicInfo = useSelector(state => (state.data.BIBasicInfo || {}).tbl_rows || []);
  const preHeight = usePrevious(height);

  const title = `${(BIBasicInfo[0] || [])[0] || ''} ${(BIBasicInfo[0] || [])[1] || ''}`;

  const data = JSON.parse(JSON.stringify(BIBasicInfo));
  data.splice(0, 1);

  useEffect(() => {
    getBIBasicInfo();
    return () => clearKey('BIBasicInfo');
  }, []);

  useEffect(() => {
    if (containRef.current && ((preHeight === height) && (height !== containRef.current.clientHeight))) {
      setHeight(containRef.current.clientHeight);
    }
  });

  return (
    <BCIF_Container title='基本資料檢視'>
      {BIBasicInfo.length === 0 && <div style={{ margin: 20, fontSize: 20, textAlign: 'center' }}>(暫無資料)</div>}
      {BIBasicInfo.length > 0 && (
        <div style={{ position: 'relative', height }}>
          <img style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'bottom', pointerEvents: 'none' }} src={Basic_cloud} alt='' />
          <div ref={containRef} style={{ position: 'absolute', top: 0, left: 0, right: 0, display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginTop: 40, marginLeft: 75, marginRight: 75, marginBottom: 66 }}>

              <div style={{ display: 'flex' }}>
                <div style={ {
                  backgroundColor: '#4CC2CA',
                  height: 50,
                  borderTopLeftRadius: 11,
                  position: 'relative',
                }}
                >
                  <div style={{ lineHeight: ' 50px', color: 'white', fontWeight: 700, fontSize: 20, marginLeft: 8, marginRight: 20 }}>{title}</div>
                  <div
                    style={{
                      backgroundColor: '#4CC2CA',
                      height: 50,
                      width: 40,
                      clipPath: 'polygon(0% 100%, 0% 0%, 30% 0%, 100% 100%)',
                      position: 'absolute',
                      top: 0,
                      left: ' calc(100% - 1px)',
                    }}
                  />
                </div>
              </div>

              <TableContainer style={{ backgroundColor: 'white', borderRadius: 8, borderTopLeftRadius: 0, boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}>
                <Table>
                  <TableBody>
                    {data.map((ary = [], i) => <MyTableRow key={i} ary={ary} />)}
                  </TableBody>
                </Table>
              </TableContainer>

            </div>
          </div>
        </div>
      )}
    </BCIF_Container>
  );
};

const MyTableRow = ({ ary }) => {
  const [over, setOver] = useState(false);
  return (
    <TableRow onMouseOver={() => { setOver(true); }} onMouseOut={() => { setOver(false); }}>
      {ary.map((t, i) => (
        <TableCell key={i} style={{ width: '50%', backgroundColor: over ? '#d8d8d8' : (i === 0 ? '#F9FCFC' : 'transparent') }} align='center'>
          {t}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default App;
